// extracted by css-extract-rspack-plugin
export default {"codeContainer":"SijRy"};